module.exports = __webpack_public_path__ + "img/icon (10).4476eaa7.png";